export default {
  BOOK_BONUS_GAME: 'book_bonus_game'
};
